module.exports = __webpack_public_path__ + "img/tradecore-logo.12584402.svg";